import type { IHelpdeskLimits } from "@kuika/kuika-cl-model";

export interface IHelpdeskNewTicketFields {
  subject: string;
  description: string;
  appMail: string;
  appPassword: string;
}

export interface IHelpdeskNewTicketErrors {
  subject?: string;
  description?: string;
  appMail?: string;
  appPassword?: string;
}

// Deliberately simple: the ITSM validates the address again; this only catches obvious typos.
const EMAIL_PATTERN: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}

/** The same rules the ITSM applies (contract §3.1), so a request is refused before it is sent. */
export function validateNewTicket(fields: IHelpdeskNewTicketFields, limits: IHelpdeskLimits): IHelpdeskNewTicketErrors {
  const errors: IHelpdeskNewTicketErrors = {};
  const subject: string = fields.subject.trim();
  const appMail: string = fields.appMail.trim();

  if (!subject) {
    errors.subject = "Subject is required";
  } else if (subject.length > limits.subjectMaxLength) {
    errors.subject = `Subject can be at most ${limits.subjectMaxLength} characters`;
  }

  if (!fields.description.trim()) {
    errors.description = "Description is required";
  } else if (fields.description.length > limits.descriptionMaxLength) {
    errors.description = `Description can be at most ${limits.descriptionMaxLength} characters`;
  }

  if (appMail && (!isValidEmail(appMail) || appMail.length > limits.appMailMaxLength)) {
    errors.appMail = "Enter a valid e-mail address";
  }

  if (fields.appPassword.length > limits.appPasswordMaxLength) {
    errors.appPassword = `Password can be at most ${limits.appPasswordMaxLength} characters`;
  }

  return errors;
}

export function hasErrors(errors: IHelpdeskNewTicketErrors): boolean {
  return Object.values(errors).some((message: string | undefined): boolean => !!message);
}
